import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { customQueryClient } from '../../config/query-client'
import {
  bulkOperationsMutationKeys,
  bulkOperationsQueryKeys
} from '../constants'

export const useCreateBulkTasksMutation = (options) => {
  const handleMutation = async ({
    taskTemplate,
    projectId,
    pinIds,
    filterId
  }) => {
    const config = {
      method: 'post',
      data: {
        taskTemplate,
        projectId,
        pinIds,
        filterId
      }
    }

    const { data } = await api('/api/v2/bulk/tasks/create', config)
    return data
  }

  const invalidTrackOperationQuery = (mutationParams) => {
    const { projectId } = mutationParams
    customQueryClient.invalidateQueries({
      queryKey: [bulkOperationsQueryKeys.BULK_TRACK_OPERATIONS_LIST, projectId]
    })
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: bulkOperationsMutationKeys.CREATE_BULK_TASKS,
    retry: 0,
    ...options,
    onSuccess: (data, mutationParams, context) => {
      invalidTrackOperationQuery(mutationParams)
      options.onSuccess?.(data, mutationParams, context)
    }
  })
}
